import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { PickTicketDetailListTemplate } from "themes/application/pick-ticket/pages";
import { PickTicketDetailListViewStore } from "application/pick-ticket/stores";

@setCurrentView(rootStore => new PickTicketDetailListViewStore(rootStore), "pickTicketDetailListViewStore")
@observer
class PickTicketDetailList extends React.Component {
    render() {
        return <PickTicketDetailListTemplate {...this.props} />;
    }
}

export default PickTicketDetailList;